import React, { FC, useEffect, useMemo, useState } from 'react';
import { authSelector, getServices, getSupportItems, Support, supportSelector, useAppDispatch } from "../../../state";
import { useSelector } from 'react-redux';
import { Container } from 'react-bootstrap';
import { TitleText } from '../../atoms';
import { ErrorAlert } from '../../molecules';
import { t } from 'i18next';
import type { MRT_ColumnDef } from 'material-react-table';
import { MaterialReactTable } from 'material-react-table';
import type { ColumnFiltersState, PaginationState, SortingState, } from '@tanstack/react-table';
import { getSortParameters, OrderEnum } from '../../utils';
import { useNavigate, useParams } from 'react-router-dom';
import { PrimaryButton } from '../../atoms/PrimaryButton';

interface Props {
}

export const SupportListContent: FC<Props> = () => {
    //table state
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [sorting, setSorting] = useState<SortingState>([]);
    const {supportId: parentId} = useParams();
    const [pagination, setPagination] = useState<PaginationState>({
        pageIndex: 0,
        pageSize: 10,
    });
    const dispatch = useAppDispatch();
    let navigate = useNavigate();
    const supportState = useSelector(supportSelector);
    let authState = useSelector(authSelector);

    const columns = useMemo<MRT_ColumnDef<Support>[]>(
        () => [
            {
                header: t('fields.support.single.title'),
                accessorKey: 'title'
            },
            {
                header: t('fields.support.single.supportType'),
                accessorKey: 'supportType',
                minSize: 50,
                maxSize: 100
            },
            // {
            //     header: t('fields.service.single.typeDescription'),
            //     accessorKey: 'service.name',
            //     minSize: 50,
            //     maxSize: 150,
            // },
        ],
        [],
    );
    useEffect(() => {
        dispatch(getServices({jwtToken: authState.jwtToken!}));
    }, [dispatch, authState.jwtToken]);
    useEffect(() => {
        let sortParameters = getSortParameters(sorting, {field: 'id', order: OrderEnum.desc});

        dispatch(getSupportItems({
            jwtToken: authState.jwtToken!,
            parentId: parentId,
            page: pagination.pageIndex,
            pageSize: pagination.pageSize,
            sortParameters
        }))
    }, [
        parentId,
        dispatch,
        authState.jwtToken,
        columnFilters,
        globalFilter,
        pagination.pageIndex,
        pagination.pageSize,
        sorting
    ]);

    function add() {
        navigate('/manage/support/add');
    }

    function getTitle() {
        if(parentId === undefined){
            return (<></>)
        } else {
            return (<TitleText>Onderliggende support items</TitleText>);
        }
    }

    return (
        <Container>
            {getTitle()}
            <ErrorAlert
                errorMessage={t('error.retrievingData')}
                show={supportState.error !== undefined}/>

            <MaterialReactTable
                columns={columns}
                data={supportState.list}
                manualFiltering
                manualPagination
                manualSorting
                enableRowSelection={false}
                enableGlobalFilter={false}
                enableColumnFilters={false}
                enableColumnOrdering={false}
                enableFullScreenToggle={false}
                enableDensityToggle={false}
                enableHiding={false}
                enableTopToolbar={false}
                onColumnFiltersChange={setColumnFilters}
                onGlobalFilterChange={setGlobalFilter}
                onPaginationChange={setPagination}
                onSortingChange={setSorting}
                rowCount={supportState.totalElements}
                state={{
                    pagination,
                    sorting
                }}
                muiTableBodyRowProps={({row}) => ({
                    onClick: (event) => {
                        navigate('/manage/support/' + row.original.id);
                    },
                    sx: {
                        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                    },
                })}
            />
            <PrimaryButton sx={{mt: 2}} onClick={add}>{t('generic.add')}</PrimaryButton>
        </Container>
    )


};
